<div class="column-menu">
  @if (this.sortable) {
    <div class="menu-item" [class.is-active]="this.sort() === 'asc'" (click)="this.setSort('asc')">
      <cam-font-icon class="menu-icon" name="arrow-big-top" type="xs"></cam-font-icon>
      <cam-text size="sm">{{ 'grid.column-menu.sort-asc' | translate }}</cam-text>
    </div>
    <div class="menu-item" [class.is-active]="this.sort() === 'desc'" (click)="this.setSort('desc')">
      <cam-font-icon class="menu-icon" name="arrow-big-bottom" type="xs"></cam-font-icon>
      <cam-text size="sm">{{ 'grid.column-menu.sort-desc' | translate }}</cam-text>
    </div>
  }

  @if (this.filterEnabled) {
    <div #filterSlot class="menu-filter"></div>

    @if (this.hasFilter()) {
      <div class="menu-item menu-clear" (click)="this.clear()">
        <cam-font-icon class="menu-icon" name="close-tool" type="xs"></cam-font-icon>
        <cam-text size="sm" color="secondary">{{ 'grid.column-menu.clear' | translate }}</cam-text>
      </div>
    }
  }
</div>
